const SETTINGS = {
    INIT_SETTINGS: 'INIT_SETTINGS',
    UPDATE_SETTINGS: 'UPDATE_SETTINGS',
    CHANGE_WIDGET_DIMENSION: 'CHANGE_WIDGET_DIMENSION',
    CHANGE_DEVICE_TYPE: 'CHANGE_DEVICE_TYPE',
    UPDATE_SLIDES: 'UPDATE_SLIDES',
    PREVIEW_TEMPLATE_SLIDES: 'PREVIEW_TEMPLATE_SLIDES', 
    STOP_SHOW_TEMPLATE: 'STOP_SHOW_TEMPLATE', 
    ADD_LANGUAGE_TO_CAPTIONS: 'ADD_LANGUAGE_TO_CAPTIONS', 
}

export {SETTINGS}